import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1c01f3e&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d1c01f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c01f3e",
  null
  
)

export default component.exports